import React, { FC } from 'react';
import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PriceRequestStatus } from 'models/price-request';

const STATUS_COLOR: Record<PriceRequestStatus, ChipProps['color']> = {
    [PriceRequestStatus.DRAFT]: 'default',
    [PriceRequestStatus.SENT]: 'info',
    [PriceRequestStatus.RESPONDED]: 'warning',
    [PriceRequestStatus.APPROVED]: 'success',
    [PriceRequestStatus.REJECTED]: 'default',
    [PriceRequestStatus.CANCELLED]: 'default',
};

/** DD-3697: a request's status — always with text, the colour only supports it. */
const PriceRequestStatusChip: FC<{ status: PriceRequestStatus }> = ({ status }) => {
    const { t: translate } = useTranslation('price-requests');
    return (
        <Chip
            size="small"
            color={STATUS_COLOR[status]}
            variant={status === PriceRequestStatus.DRAFT ? 'outlined' : 'filled'}
            label={translate(`STATUS_${status}`)}
            data-test={`price-request.status-${status}`}
        />
    );
};

export default PriceRequestStatusChip;
